// 页面类型枚举
export const pageTypeMap = {
  food: 1,
  grocery: 3,
}

// 券包类型
export const couponCategoryMap = {
  food: 8,
  grocery: 7,
}

export const FOOD_SCENARIO_CODE = 'WM-0010' // 外卖券包支付码
export const GROCERY_SCENARIO_CODE = 'SC-0008' // 商超券包支付码

// 券包规则页
// eslint-disable-next-line no-template-curly-in-string
export const RULE_PAGE_URL = '/${locale}/couponPack/rule'
